// extracted by mini-css-extract-plugin
module.exports = {"partners":"Partners_partners__1LsIj","header":"Partners_header__3GG1D","partnersList":"Partners_partnersList__36ol_","partnersLogo":"Partners_partnersLogo__1BLc8"};